import {IApp} from "@/interfaces/app.interface";
import {IMovementsReport} from "@/modules/Report/Movements/interfaces/movements-report.interface";
import {IReport} from "@/modules/Report/interfaces/report.interface";

export class MovementsConfig {
  useBigTable = false;

  allTableCells = () => {
    const dateInOutFormat = IApp.DateFormats.PrintedSymbolDateTime;
    const timeParkLabel = this.useBigTable ? 'Стоянка' : 'Сто-<br>янка';

    const infoByProp = {
      // string
      movId:        { label: 'Код',                     propType: IApp.SortingPropType.String, },
      persName:     { label: 'ФИО',                     propType: IApp.SortingPropType.String, },
      corpName:     { label: 'Корпорация',              propType: IApp.SortingPropType.String, },
      parkName:     { label: 'Парковка',                propType: IApp.SortingPropType.String, colspan: 2, },
      carTypeName:  { label: 'Цель визита<br>Тип авто', propType: IApp.SortingPropType.String, },
      comment:      { label: 'Комментарий',             propType: IApp.SortingPropType.String, colspan: 4, },

      // noSorting

      // dates
      dateIn: {
        label: 'Въезд',
        propType: IApp.SortingPropType.Date,
        dateFormat: dateInOutFormat,
        useCustomDateFormat: true,
        colspan: 2,
        usePrintedValue: true,
      },
      dateOut: {
        label: 'Выезд',
        propType: IApp.SortingPropType.Date,
        dateFormat: dateInOutFormat,
        useCustomDateFormat: true,
        colspan: 2,
        usePrintedValue: true,
      },

      // number
      balance:    { label: 'Сумма',         propType: IApp.SortingPropType.Number, isMoney: true, usePrintedValue: true, },
      saldo:      { label: 'Сальдо корп.',  propType: IApp.SortingPropType.Number, isMoney: true, usePrintedValue: true, },
      subParkSum: { label: 'КПП2',          propType: IApp.SortingPropType.Number, isMoney: true, usePrintedValue: true, },
      driverSum:  { label: 'Водитель',      propType: IApp.SortingPropType.Number, isMoney: true, usePrintedValue: true, },
      payGuestHoursMov: { label: 'ЧЗГ',     propType: IApp.SortingPropType.Number, tooltip: 'Оплата часов за гостя', },
      timePark:   { label: timeParkLabel,   propType: IApp.SortingPropType.Number, usePrintedValue: true, },

      // custom template
      paySum: {
        label: 'Оплата',
        propType: IApp.SortingPropType.CustomComponent,
        customComponentName: 'PayCell',
      },
      carNumber: {
        label: 'Номер',
        propType: IApp.SortingPropType.CustomComponent,
        customComponentName: 'CarNumberCell',
      },

      // actions
      actions: { label: 'Действия', propType: IApp.SortingPropType.Actions, noPrint: true, },
    };

    return infoByProp;
  }

  getTableCells(useBigTable: boolean, configType: IMovementsReport.TableConfigType): IReport.ITableProp[] {
    this.useBigTable = useBigTable;
    const infoByProp = this.allTableCells();
    let resultCells = [];
    const baseCellProps = [
      'movId',
      'persName',
      'corpName',
      'carNumber',
      'dateIn',
      'dateOut',
      'timePark',
      'balance',
      'paySum',
      'parkName',
      'carTypeName',
      'comment',
      'actions',
    ];

    switch (configType) {
      case IMovementsReport.TableConfigType.WithKPPAndDriver:
        resultCells = [...baseCellProps];
        let props = [
          { name: 'subParkSum', pos: 8 },
          { name: 'driverSum', pos: 9 },
          { name: 'saldo', pos: 11 },
          { name: 'payGuestHoursMov', pos: 12 },
        ];
        props.forEach(prop => resultCells.splice(prop.pos, 0, prop.name));
        break;

      default:
        resultCells = [...baseCellProps];
        break;
    }

    let tableCells: IReport.ITableProp[] = [];
    resultCells.forEach(cellProp => {
      tableCells.push({
        prop: cellProp,
        ...infoByProp[cellProp]
      });
    });

    return tableCells;
  }
}

export const movementsConfig = new MovementsConfig();